// sections/Section.jsx
import React from 'react';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function Section({ title, icon, children, sx }) {
  return (
    <MDBox sx={sx}>
      <MDBox display="flex" alignItems="center" gap={0.8} sx={{ mb: 0.25 }}>
        {icon ? <Icon fontSize="small">{icon}</Icon> : null}
        <MDTypography variant="button" fontWeight="bold">
          {title}
        </MDTypography>
      </MDBox>
      {children}
    </MDBox>
  );
}
